
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["share-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"38","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"50","cy":"50","fill":"#f37b8a","r":"50"}}),_c('path',{attrs:{"d":"M68.773 30.995a26.6 26.6 0 00-41.892 32.089l-3.747 13.783 14.1-3.7a26.578 26.578 0 0012.614 3.235 26.6 26.6 0 0018.925-45.407zM49.852 71.91a22.063 22.063 0 01-11.238-3.072l-.814-.489-8.358 2.188 2.327-8.169-.536-.7a22.11 22.11 0 1118.619 10.358zm12.125-16.548c-.675-.325-3.933-1.932-4.655-2.165s-1.048-.325-1.489.325-1.719 2.162-2.094 2.608-.768.489-1.443.163a18.154 18.154 0 01-5.357-3.3 20.016 20.016 0 01-3.7-4.655c-.4-.675 0-1.024.3-1.35s.675-.768 1-1.164a4.655 4.655 0 00.675-1.117 1.233 1.233 0 000-1.164c-.163-.325-1.489-3.607-2.048-4.934s-1.094-1.117-1.489-1.141h-1.134a2.327 2.327 0 00-1.769.838 7.447 7.447 0 00-2.327 5.539 12.917 12.917 0 002.72 6.982 29.627 29.627 0 0011.36 10.031 38.169 38.169 0 003.794 1.4 9.1 9.1 0 004.189.256 6.847 6.847 0 004.467-3.166 5.563 5.563 0 00.4-3.166c-.188-.325-.628-.489-1.28-.814z","fill-rule":"evenodd","data-name":"Group 463"}})])
          )
        }
      }
    